export const DEFAULT_IMG = `${process.env.NEXT_PUBLIC_IMAGE_SERVICE_URL}/images/fallback/coming-soon.webp`;
